import React from 'react';
import { motion } from 'framer-motion';
import { skpPipeline } from '../../data/research';
import { fadeUp } from '../../utils/motion';
export function ResearchSkp() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-1328" data-mp="1gc6fuxiwbin5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1329" data-mp="1gbo9h82iro1i">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1330" data-mp="1lare4rel7s8y">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight" data-id="element-1331" data-mp="16luz2ae45eyu">
            Connecting knowledge through SKP
          </h2>
          <div className="lg:col-span-7 space-y-5" data-id="element-1332" data-mp="xlyiyx5shofe">
            <p className="text-xl text-ink-dark leading-relaxed" data-id="element-1333" data-mp="xn9igks7ca0p">
              Research is often distributed across papers, disciplines,
              organizations, and incompatible terminology. SKP is designed to
              turn that scattered information into connected knowledge that
              people can search, examine, challenge, and extend.
            </p>
            <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1334" data-mp="1o5rna0o7mpbi">
              Its proposed architecture combines structured content, governed
              vocabularies, AI-assisted extraction, expert review, a knowledge
              graph, semantic search, and GraphRAG. An LLM can propose concepts
              and relationships from a document, while validation rules and
              reviewers determine what enters the approved graph. Each approved
              connection retains its source and version history.
            </p>
          </div>
        </motion.div>

        <motion.ol {...fadeUp} aria-label="SKP architecture" className="mt-14 grid grid-cols-1 md:grid-cols-5 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-1335" data-mp="1e96gpawjl65k">
          {skpPipeline.map((stage, index) => <li key={stage} className={`p-5 lg:p-6 ${index === 2 ? 'bg-navy text-white' : 'bg-white text-ink-dark'}`} data-id="element-1336" data-mp="lq97kdg29u1f" data-mpi={index}>
              <span className={`block text-xs font-medium mb-2 ${index === 2 ? 'text-white/70' : 'text-teal'}`} data-id="element-1337" data-mp="2guh3xvocapga">
                {index === 2 ? 'Decides what enters' : `Stage ${index + 1}`}
              </span>
              <span className="font-heading font-bold leading-snug" data-id="element-1338" data-mp="2qmmv536rp2uf">{stage}</span>
            </li>)}
        </motion.ol>

        <motion.div {...fadeUp} className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16" data-id="element-1339" data-mp="2vmhln5mmrqey">
          <div data-id="element-1340" data-mp="1xyzbbqdbmg8u">
            <h3 className="font-heading font-bold text-xl text-ink-dark mb-3" data-id="element-1341" data-mp="22vpn41i3epog">For scientific research</h3>
            <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1342" data-mp="27v2biqom44t5">
              This can help investigators connect organisms, conditions,
              interventions, populations, outcomes, and related ideas across
              studies.
            </p>
          </div>
          <div data-id="element-1343" data-mp="3jc265syfmvqc">
            <h3 className="font-heading font-bold text-xl text-ink-dark mb-3" data-id="element-1344" data-mp="3nbkmscj80knd">For NCJI</h3>
            <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1345" data-mp="3ndf6xomo48qe">
              The same infrastructure can connect capability definitions,
              assessment tasks, scoring rules, development activities, role
              requirements, policies, and outcomes.
            </p>
          </div>
        </motion.div>

        <motion.p {...fadeUp} className="mt-14 font-heading font-bold text-2xl lg:text-3xl text-ink-dark leading-snug max-w-4xl border-l-4 border-teal pl-6" data-id="element-1346" data-mp="xxcd2n1gi5wu">
          SKP defines and connects approved knowledge. It does not, on its own,
          assess a person or administer a civic decision.
        </motion.p>
      </div>
    </section>;
}